<template>
    <v-container>
        <v-overlay v-model="overlay" color="white" opacity="1" persistent>
            <v-container style="text-align: center">
                <v-progress-circular :size="50" color="#234a98" indeterminate></v-progress-circular>
                <p class="pt-2" style="font-size: 14px; color: #234a98">
                    {{ $t('common.loading') }}
                </p>
            </v-container>
        </v-overlay>
        <v-dialog persistent max-width="600" v-model="dialogAlert">
            <v-card>
                <v-card-title>
                    {{ $t('alertsManagement.fillFields') }}
                </v-card-title>
                <v-card-text id="makeMeBlue">
                    <v-form ref="alertForm" v-model="isAlertFormValid">
                        <v-text-field 
                            v-model="alertName" 
                            :label="$t('alertsManagement.title')" 
                            outlined 
                            color="#213A8F" 
                            maxlength="50" 
                            counter 
                            :rules="[rules.required]"
                        />
                        <v-select 
                            v-model="client" 
                            color="#213A8F" 
                            outlined 
                            :items="clients" 
                            :label="$t('manageSensors.client')"
                            prepend-inner-icon="mdi-account" 
                            append-icon="mdi-arrow-down-drop-circle-outline"
                            append-icon-color="#213A8F" 
                            required 
                            v-if="showClient"
                            :rules="[rules.required]"
                        />
                        <v-layout>
                            <v-flex xs-11 md-11 sm-11>
                                <v-select 
                                    v-model="building" 
                                    color="#213A8F" 
                                    outlined 
                                    :items="buildings" 
                                    :label="$t('manageSensors.building')"
                                    prepend-inner-icon="mdi-home" 
                                    append-icon="mdi-arrow-down-drop-circle-outline"
                                    append-icon-color="#213A8F" 
                                    v-if="showBuilding"
                                />
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs-11 md-11 sm-11>
                                <v-select 
                                    v-model="floor" 
                                    color="#213A8F" 
                                    outlined 
                                    :items="floors" 
                                    :label="$t('manageSensors.floor')"
                                    prepend-inner-icon="mdi-floor-plan" 
                                    append-icon="mdi-arrow-down-drop-circle-outline"
                                    append-icon-color="#213A8F" 
                                    :key="f" 
                                    v-if="showFloor"
                                />
                            </v-flex>
                        </v-layout>

                        <v-layout>
                            <v-flex xs-11 md-11 sm-11>
                                <v-select 
                                    v-model="area" 
                                    color="#213A8F" 
                                    outlined 
                                    :items="areas" 
                                    :label="$t('manageSensors.area')"
                                    prepend-inner-icon="mdi-texture-box" 
                                    append-icon="mdi-arrow-down-drop-circle-outline"
                                    append-icon-color="#213A8F" 
                                    :key="a" 
                                    v-if="showArea"
                                />
                            </v-flex>
                        </v-layout>
                        <!-- <v-select v-model="sensore" color="#213A8F" outlined :items="sensors" label="Select one sensor"
                            prepend-inner-icon="mdi-access-point-network" append-icon="mdi-arrow-down-drop-circle-outline"
                            append-icon-color="#213A8F" /> -->
                        <v-layout>
                            <v-flex xs-11 md-11 sm-11>
                                <v-select 
                                    v-model="sensor" 
                                    multiple 
                                    prepend-inner-icon="mdi-access-point-network"
                                    append-icon="mdi-arrow-down-drop-circle-outline" 
                                    :items="filteredSensors" 
                                    :label="$t('manageSensors.sensor')"
                                    outlined 
                                    v-if="showSensor"
                                    :rules="[rules.required]"
                                />
                            </v-flex>
                        </v-layout>
                        <v-text-field 
                            v-model="email" 
                            color="#213A8F" 
                            outlined 
                            :label="$t('alertsManagement.emailLabel')"
                            prepend-inner-icon="mdi-email"
                            :rules="[rules.required, rules.email]"
                        />
                        <v-text-field 
                            v-model="emailCustomMessage" 
                            color="#213A8F" 
                            outlined
                            :label="$t('alertsManagement.customMessage')" 
                            prepend-inner-icon="mdi-email"
                        />
                        <!-- <v-text-field v-model="sms" color="#213A8F" outlined label="Sms number (use ; to separate phone numbers)" prepend-inner-icon="mdi-message"/> -->
                        <!-- Select per sensori Air: scelta del campo da monitorare -->
                        <v-select 
                            v-if="showAirFieldSelect"
                            v-model="alertField" 
                            color="#213A8F" 
                            outlined 
                            :items="airFieldOptions" 
                            :label="$t('alertsManagement.airField')"
                            prepend-inner-icon="mdi-air-filter" 
                            append-icon="mdi-arrow-down-drop-circle-outline"
                            append-icon-color="#213A8F" 
                            :rules="[rules.required]"
                        />
                        
                        <!-- Select per l'operatore di confronto (solo per sensori Air) -->
                        <v-select 
                            v-if="showAirFieldSelect"
                            v-model="comparisonOperator" 
                            color="#213A8F" 
                            outlined 
                            :items="comparisonOperatorOptions" 
                            :label="$t('alertsManagement.comparisonOperator')"
                            prepend-inner-icon="mdi-compare" 
                            append-icon="mdi-arrow-down-drop-circle-outline"
                            append-icon-color="#213A8F" 
                            :rules="[rules.required]"
                        />
                        
                        <!-- Select per sensori Button: scelta del tipo di pressione -->
                        <v-select 
                            v-if="showButtonFieldSelect"
                            v-model="alertField" 
                            color="#213A8F" 
                            outlined 
                            :items="buttonFieldOptions" 
                            :label="$t('alertsManagement.buttonField')"
                            prepend-inner-icon="mdi-gesture-tap-button" 
                            append-icon="mdi-arrow-down-drop-circle-outline"
                            append-icon-color="#213A8F" 
                            :rules="[rules.required]"
                        />
                        
                        <v-text-field 
                            v-if="showAlertValueField"
                            v-model="alertValue" 
                            color="#213A8F" 
                            outlined 
                            :label="$t('alertsManagement.alertValue')"
                            prepend-inner-icon="mdi-alert"
                            :rules="showAlertValueField ? [rules.required, rules.number] : []"
                        />

                        <!-- <v-switch class="justify-right" v-model="active" :label="active ? 'Active' : 'Disabled'"></v-switch> -->
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#213A8F" @click="dialogAlert = false">{{ $t('common.cancel') }}</v-btn>
                    <v-btn text color="#213A8F" @click="SaveData" :disabled="!isAlertFormValid">{{ $t('alertsManagement.saveRule') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <!-- Dialog di conferma eliminazione -->
        <v-dialog persistent max-width="500" v-model="dialogDeleteConfirm">
            <v-card>
                <v-card-title class="headline">
                    {{ $t('alertsManagement.deleteConfirm.title') }}
                </v-card-title>
                <v-card-text>
                    <p>{{ $t('alertsManagement.deleteConfirm.message', { title: itemToDelete?.Title }) }}</p>
                    <p class="text-caption text--secondary">{{ $t('alertsManagement.deleteConfirm.description') }}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#213A8F" @click="dialogDeleteConfirm = false">
                        {{ $t('common.cancel') }}
                    </v-btn>
                    <v-btn text color="red" @click="confirmDelete">
                        {{ $t('common.delete') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <!-- Overlay di caricamento per eliminazione -->
        <v-overlay :value="isDeleting" z-index="9999">
            <v-progress-circular
                indeterminate
                size="64"
                color="#213A8F"
            ></v-progress-circular>
            <div class="mt-4 text-center">
                <p class="white--text">{{ $t('common.loading') }}</p>
            </div>
        </v-overlay>
        
        <!-- Sezione filtri -->
        <v-card class="mt-4 mb-4">
            <v-layout id="makeMeBlue">
                <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                    <v-select v-model="filterClient" color="#213A8F" outlined :items="filterClients" :label="$t('manageSensors.client')"
                        prepend-inner-icon="mdi-account" append-icon="mdi-arrow-down-drop-circle-outline"
                        append-icon-color="#213A8F" :no-data-text="$t('common.noDataAvailable')" />
                </v-flex>
                <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                    <v-select prepend-inner-icon="mdi-home" v-model="filterBuilding" :items="filterBuildings" :label="$t('manageSensors.building')"
                        outlined append-icon="mdi-arrow-down-drop-circle-outline" :no-data-text="$t('common.noDataAvailable')">
                    </v-select>
                </v-flex>
                <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                    <v-select prepend-inner-icon="mdi-floor-plan" class="ml-2"
                        append-icon="mdi-arrow-down-drop-circle-outline" v-model="filterFloor" :items="filterFloors"
                        :label="$t('manageSensors.floor')" outlined :no-data-text="$t('common.noDataAvailable')">
                    </v-select>
                </v-flex>
                <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                    <v-select v-model="filterArea" color="#213A8F" outlined :items="filterAreas" :label="$t('manageSensors.area')"
                        prepend-inner-icon="mdi-texture-box" append-icon="mdi-arrow-down-drop-circle-outline"
                        append-icon-color="#213A8F" :no-data-text="$t('common.noDataAvailable')" />
                </v-flex>
                <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                    <v-select v-model="filterSensor" prepend-inner-icon="mdi-access-point-network"
                        append-icon="mdi-arrow-down-drop-circle-outline" :items="filterSensors" :label="$t('manageSensors.sensor')" outlined
                        :no-data-text="$t('common.noDataAvailable')">
                    </v-select>
                </v-flex>
            </v-layout>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="ClearFilter">
                    <span style="color: #213A8F;">{{ $t('manageSensors.clearFilter') }}</span>
                    <v-icon color="#213A8F" left>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
        
        <v-card class="pt-4">
            <div class="mb-2 ml-4">
                <v-btn color="#213A8F" dark @click="CreateNew()" elevation="2">
                    <v-icon left>mdi-plus-circle-outline</v-icon>
                    {{ $t('alertsManagement.addNewAlert') }}
                </v-btn>
            </div>
            <v-card-text>
                <div class="table-responsive">
                    <v-data-table 
                        v-bind:headers="headers" 
                        :items="list" 
                        :hide-default-footer="true" 
                        disable-pagination
                        class="elevation-1 mt-4" 
                        :no-data-text="$t('manageSensors.noDataAvailable')"
                        :mobile-breakpoint="0"
                    >
                        <template v-slot:item="{ item }">
                            <tr>
                                <!-- Stato (Toggle Switch) -->
                                <td class="text-center" style="white-space: nowrap;">
                                    <div style="display: flex; justify-content: center; align-items: center;">
                                        <v-switch
                                            v-model="item.Active"
                                            :true-value="1"
                                            :false-value="0"
                                            color="green"
                                            inset
                                            dense
                                            hide-details
                                            @change="toggleAlertStatus(item)"
                                            class="mt-0 pt-0"
                                        ></v-switch>
                                    </div>
                                </td>
                                <!-- Azioni (Edit, Delete) -->
                                <td class="text-center" style="white-space: nowrap;">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon 
                                                color="#213A8F" 
                                                class="mr-2" 
                                                @click="OpenDialog(item)"
                                                v-bind="attrs"
                                                v-on="on"
                                            >mdi-pencil</v-icon>
                                        </template>
                                        <span>{{ $t('manageSensors.tooltips.edit') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon 
                                                color="#213A8F" 
                                                @click="DeleteAlert(item)"
                                                v-bind="attrs"
                                                v-on="on"
                                            >mdi-delete</v-icon>
                                        </template>
                                        <span>{{ $t('manageSensors.tooltips.delete') }}</span>
                                    </v-tooltip>
                                </td>
                                <!-- Nome Alert -->
                                <td>{{ item.Title }}</td>
                                <!-- Sensore -->
                                <td>{{ item.DisplayName }}</td>
                                <!-- Destinatari -->
                                <td class="email-cell">{{ item.EmailAddress }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
import axios from "axios";
export default {
    data() {
        return {
            dispenserMessage: "Paper level low. Please refill promptly.",
            doorMessage: "High activity detected. Please schedule cleaning.",
            airMessage: "Air quality alert. Please verify ventilation.",
            smartButtonMessage: "Multiple negative feedbacks received. Please inspect cleanliness urgently.",
            smartBinMessage: "Waste bin full. Please empty immediately.",
            filteredSensors: [],
            showClient: true,
            emailCustomMessage: '',
            showSensor: true,
            showBuilding: false,
            showFloor: false,
            showArea: false,
            showAirFieldSelect: false,
            showButtonFieldSelect: false,
            showAlertValueField: true,
            alertField: '',
            comparisonOperator: '',
            airFieldOptions: [],
            buttonFieldOptions: [],
            comparisonOperatorOptions: [],
            clients: [],
            client: '',
            buildings: [],
            building: '',
            floors: [],
            floor: '',
            areas: [],
            area: '',
            sensors: [],
            sensor: '',
            list: [],
            alertValue: 0,
            dialogAlert: false,
            dialogDeleteConfirm: false,
            itemToDelete: null,
            isDeleting: false,
            active: true,
            alertName: "",
            email: "",
            sms: "",
            id: null,
            id_sensore: '',
            sensore: '',
            display_name: '',
            isAlertFormValid: false,
            overlay: false,
            // Variabili per i filtri
            filterClients: [],
            filterClient: '',
            filterBuildings: [],
            filterBuilding: '',
            filterFloors: [],
            filterFloor: '',
            filterAreas: [],
            filterArea: '',
            filterSensors: [],
            filterSensor: '',
            rules: {
                required: v => !!v || 'This field is required',
                email: v => {
                    if (!v) return true;
                    const emails = v.split(';').map(email => email.trim());
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    return emails.every(email => emailRegex.test(email)) || 'Please enter valid email addresses';
                },
                number: v => {
                    if (!v) return true;
                    return !isNaN(v) && v > 0 || 'Please enter a valid positive number';
                }
            },
        }
    },
    computed: {
        headers() {
            return [
                { text: this.$t('alertsManagement.status'), align: "center", value: "Active", sortable: false, width: "120px" },
                { text: this.$t('manageSensors.actions'), align: "center", value: "Actions", sortable: false, width: "150px" },
                { text: this.$t('alertsManagement.alertName'), align: "center", value: "Title" },
                { text: this.$t('alertsManagement.sensor'), align: "center", value: "DisplayName" },
                { text: this.$t('alertsManagement.recipients'), align: "center", value: "EmailAddresses" }
            ]
        }
    },
    created() {
        this.overlay = true;
        axios.post(this.$store.state.URL_COMPANY_DATA, {
            "Company": this.$store.state.company
        })
            .then(() => {
                axios.post(this.$store.state.URLGETALERTSENSORS, {
                    "company": this.$store.state.company
                })
                    .then(res => {
                        this.sensors.length = 0;
                        if (res.data) {
                            res.data.forEach(el => {
                                var e = {
                                    DisplayName: el.DisplayName,
                                    DispenserUnique: el.DispenserUnique,

                                }
                                this.sensors.push({ text: el.DisplayName, value: e });
                            })
                        }
                    })
                    .catch(() => {
                        this.overlay = false;
                    })
            })
            .catch(() => {
                this.overlay = false;
                this.$router.push({ path: "/" });
            })
    },
    mounted() {
        // Inizializza le opzioni per i campi Air (localizzate)
        this.airFieldOptions = [
            { text: this.$t('alertsManagement.airFields.pressure'), value: 'PRESSIONE' },
            { text: this.$t('alertsManagement.airFields.co2'), value: 'CO2' },
            { text: this.$t('alertsManagement.airFields.temperature'), value: 'TEMPERATURA' },
            { text: this.$t('alertsManagement.airFields.humidity'), value: 'UMIDITA' }
        ];
        
        // Inizializza le opzioni per i campi Button (localizzate)
        this.buttonFieldOptions = [
            { text: this.$t('alertsManagement.buttonFields.short'), value: 'short' },
            { text: this.$t('alertsManagement.buttonFields.long'), value: 'long' },
            { text: this.$t('alertsManagement.buttonFields.double'), value: 'double' }
        ];
        
        // Inizializza le opzioni per l'operatore di confronto (localizzate)
        this.comparisonOperatorOptions = [
            { text: this.$t('alertsManagement.operators.greaterThan'), value: '>' },
            { text: this.$t('alertsManagement.operators.lessThan'), value: '<' }
        ];
        
        // Carica i clienti per i filtri
        axios.post(this.$store.state.URL_GET_AVAILABLE_CLIENT)
            .then(res => {
                res.data.forEach(el => {
                    var element = { text: el.CompanyName, value: el.id }
                    this.clients.push(element);
                    this.filterClients.push(element);
                })
                // Carica i dati degli alert
                this.GetAlertData();
            })
            .catch(() => {
                this.overlay = false;
            })
    },
    methods: {
        DeleteAlert(item) {
            this.itemToDelete = item;
            this.dialogDeleteConfirm = true;
        },
        toggleAlertStatus(item) {
            // Aggiorna lo stato dell'alert nel database chiamando l'API con tutti i campi
            this.overlay = true;
            
            // Determina alertCondition in base al tipo di sensore
            let alertCondition = 'lt'; // default
            if (item.DispenserType === "Cestino" || item.DispenserType === "Washroom" || item.DispenserType === "Button") {
                alertCondition = "gt";
            } else if (item.DispenserType === "Air") {
                // Per Air, usa il comparisonOperator salvato
                alertCondition = item.ComparisonOperator === '>' ? 'gt' : 'lt';
            }
            
            const payload = {
                id: item.Id,
                title: item.Title,
                sensors: [item.IdSensore], // Array con l'ID del sensore
                emails: item.EmailAddress,
                customMessage: item.CustomMessage || item.EmailCustomMessage || '',
                // Per Button con subtype 'click', alertValue può essere 0
                alertValue: item.AlertValue || 0,
                alertCondition: alertCondition,
                active: item.Active // Il nuovo stato del toggle
            };
            
            // Aggiungi alertField se presente (per sensori Air o Button)
            // Per i Button, questo campo contiene i valori: "short", "long", o "double"
            if (item.AlertField) {
                payload.alertField = item.AlertField;
                console.log(`Toggle alert status - Salvando alertField (${item.DispenserType}):`, item.AlertField);
            }
            
            console.log('Payload per toggle alert status:', payload);
            
            axios.post(this.$store.state.URL_SAVE_NEW_ALERT_CONFIGURATION, payload)
                .then(res => {
                    if (res.data == "ok") {
                        console.log('Alert status updated successfully');
                        // Ricarica i dati per assicurarsi che siano sincronizzati
                        this.GetAlertData();
                    } else {
                        console.error('Error updating alert status:', res.data);
                        // In caso di errore, ripristina il valore precedente
                        item.Active = item.Active === 1 ? 0 : 1;
                        this.overlay = false;
                    }
                })
                .catch(err => {
                    console.error('Error updating alert status:', err);
                    // In caso di errore, ripristina il valore precedente
                    item.Active = item.Active === 1 ? 0 : 1;
                    this.overlay = false;
                });
        },
        confirmDelete() {
            if (this.itemToDelete) {
                this.isDeleting = true;
                this.dialogDeleteConfirm = false;
                
                axios.post(this.$store.state.URL_DELETE_ALERT_MANAGEMENT, {
                    id: this.itemToDelete.Id
                })
                    .then(res => {
                        if (res.data == "ok") {
                            this.GetAlertData();
                            this.id = 0;
                            this.id_sensore = "";
                            this.alertName = "";
                            this.email = "";
                            this.sms = "";
                            this.active = true;
                            this.display_name = "";
                            this.itemToDelete = null;
                        }
                        else {
                            console.log(res.data);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
                    .finally(() => {
                        this.isDeleting = false;
                    });
            }
        },
        CreateNew() {
            this.showClient = true;
            this.id = null;
            this.id_sensore = "";
            this.alertName = "";
            this.email = "";
            this.sms = "";
            this.active = true;
            this.display_name = "";
            this.emailCustomMessage = "";
            this.client = "";
            this.buildings.length = 0;
            this.buildings = [];
            this.building = "";
            this.floors.length = 0;
            this.floors = [];
            this.floor = "";
            this.areas.length = 0;
            this.areas = [];
            this.area = "";
            this.sensors.length = 0;
            this.sensors = [];
            this.sensor = "";
            this.alertValue = 0;
            this.alertField = "";
            this.comparisonOperator = "";
            this.showAirFieldSelect = false;
            this.showButtonFieldSelect = false;
            this.showAlertValueField = true;
            
            // Reset della validazione del form
            this.$nextTick(() => {
                if (this.$refs.alertForm) {
                    this.$refs.alertForm.reset();
                    this.$refs.alertForm.resetValidation();
                }
            });
            
            this.dialogAlert = true;
        },
        GetAlertData() {
            this.overlay = true;
            axios.post(this.$store.state.URLGETALERTSMANAGEMENT,
                {
                    "company": this.$store.state.company,
                    "clientId": this.filterClient,
                    "buildingId": this.filterBuilding,
                    "floorId": this.filterFloor,
                    "areaId": this.filterArea,
                    "sensorId": this.filterSensor
                })
                .then(res => {
                    console.log(res.data);
                    this.list = res.data;
                    this.overlay = false;
                })
                .catch(err => {
                    console.error('Error fetching alerts:', err);
                    this.overlay = false;
                })
        },
        ClearFilter() {
            this.filterClient = '';
            this.filterBuildings.length = 0;
            this.filterBuilding = '';
            this.filterFloor = '';
            this.filterFloors.length = 0;
            this.filterArea = '';
            this.filterAreas.length = 0;
            this.filterSensors.length = 0;
            this.filterSensor = '';
            this.filterBuildings = [];
            this.filterFloors = [];
            this.filterAreas = [];
            this.filterSensors = [];
            this.GetAlertData();
        },
        getAlertCondition(sensorType) {
            // Determina il valore di alertCondition in base al tipo di sensore
            // "Cestino", "Washroom", "Button": "gt"
            // "Air": valore selezionato dall'utente (> = "gt", < = "lt")
            // Tutti gli altri: "lt"
            
            if (sensorType === "Cestino" || sensorType === "Washroom" || sensorType === "Button") {
                return "gt";
            } else if (sensorType === "Air") {
                // Per Air, usa il comparisonOperator selezionato dall'utente
                return this.comparisonOperator === '>' ? 'gt' : 'lt';
            } else {
                // Per Dispenser e tutti gli altri: "lt"
                return "lt";
            }
        },
        SaveData() {
            // Ottieni il tipo di sensore dal primo sensore selezionato
            let sensorType = '';
            if (Array.isArray(this.sensor) && this.sensor.length > 0) {
                sensorType = this.sensor[0].DispenserType;
            } else if (this.sensor && this.sensor.DispenserType) {
                sensorType = this.sensor.DispenserType;
            }
            
            const payload = {
                id: this.id,
                title: this.alertName,
                sensors: Array.isArray(this.sensor) ? this.sensor.map(sensor => sensor.id) : this.sensor.id,
                emails: this.email,
                customMessage: this.emailCustomMessage,
                // Per Button con subtype 'click', alertValue non è richiesto (impostalo a 0)
                alertValue: this.showAlertValueField ? this.alertValue : 0,
                alertCondition: this.getAlertCondition(sensorType),
                active: this.active // Passa lo stato attivo dell'alert
            };
            
            // Aggiungi alertField per sensori Air o Button
            // Per i Button, questo campo contiene i valori: "short", "long", o "double"
            if ((this.showAirFieldSelect || this.showButtonFieldSelect) && this.alertField) {
                payload.alertField = this.alertField;
                console.log(`Salvando alertField per sensore ${sensorType}:`, this.alertField);
            }
            
            console.log('Payload completo per salvataggio alert:', payload);
            
            axios.post(this.$store.state.URL_SAVE_NEW_ALERT_CONFIGURATION, payload)
                .then(res => {
                    if (res.data == "ok") {
                        this.dialogAlert = false;
                        this.GetAlertData();
                        this.id = null;
                        this.id_sensore = "";
                        this.alertName = "";
                        this.email = "";
                        this.sms = "";
                        this.active = true;
                        this.display_name = "";
                        this.alertField = "";
                        this.comparisonOperator = "";
                        this.showAirFieldSelect = false;
                        this.showButtonFieldSelect = false;
                    }
                })
                .catch(() => {
                    console.log("c'è qualcosa che non va")
                })
        },
        OpenDialog(item) {
            console.log(item);
            this.id = item.Id;
            this.alertName = item.Title;
            this.email = item.EmailAddress;
            this.active = item.Active; // Leggi lo stato attivo dell'alert
            var el = {
                text: item.DisplayName,
                value: item,

            }
            this.filteredSensors = [];
            this.filteredSensors.length = 0;
            this.sensor = {};
            this.filteredSensors.push(el);
            this.sensor = item;
            console.log(this.sensor)
            this.showClient = false;
            this.showBuilding = false;
            this.showFloor = false;
            this.showArea = false;
            this.id_sensore = item.IdSensore;
            this.display_name = item.DisplayName;
            this.alertValue = item.AlertValue;
            
            // Gestione campo Air
            if (item.DispenserType === "Air") {
                this.showAirFieldSelect = true;
                this.showButtonFieldSelect = false;
                this.showAlertValueField = true;
                this.alertField = item.AlertField || '';
                // alertValue già assegnato sopra (linea 776)
                
                // Carica il comparisonOperator dal database
                // Se c'è ComparisonOperator, usalo direttamente
                // Altrimenti converti da AlertCondition (gt -> >, lt -> <)
                if (item.ComparisonOperator) {
                    this.comparisonOperator = item.ComparisonOperator;
                } else if (item.AlertCondition) {
                    this.comparisonOperator = item.AlertCondition === 'gt' ? '>' : '<';
                } else {
                    this.comparisonOperator = '';
                }
            } else if (item.DispenserType === "Button") {
                this.showAirFieldSelect = false;
                this.comparisonOperator = '';
                
                // Mostra il campo tipo di click solo per Button con subtype 'click'
                // e nascondi il campo alertValue per questi sensori
                if (item.DispenserSubtype === 'click') {
                    this.showButtonFieldSelect = true;
                    this.showAlertValueField = false;
                    this.alertField = item.AlertField || '';
                    // Per Button click, alertValue non è rilevante (impostato a 0 se non presente)
                    this.alertValue = item.AlertValue || 0;
                } else {
                    this.showButtonFieldSelect = false;
                    this.showAlertValueField = true;
                    this.alertField = '';
                    // alertValue già assegnato sopra (linea 776)
                }
            } else {
                // Per tutti gli altri tipi (Dispenser, Washroom, Cestino, ecc.)
                this.showAirFieldSelect = false;
                this.showButtonFieldSelect = false;
                this.showAlertValueField = true;
                this.alertField = '';
                this.comparisonOperator = '';
                // alertValue già assegnato sopra (linea 776)
            }
            
            // Carica il custom message se presente, altrimenti usa quello di default in base al tipo
            if (item.CustomMessage && item.CustomMessage.trim() !== '') {
                this.emailCustomMessage = item.CustomMessage;
            } else if (item.EmailCustomMessage && item.EmailCustomMessage.trim() !== '') {
                this.emailCustomMessage = item.EmailCustomMessage;
            } else {
                // Imposta il messaggio di default in base al tipo di sensore
                switch (item.DispenserType) {
                    case "Dispenser":
                        this.emailCustomMessage = this.dispenserMessage;
                        break;
                    case "Air":
                        this.emailCustomMessage = this.airMessage;
                        break;
                    case "Washroom":
                        this.emailCustomMessage = this.doorMessage;
                        break;
                    case "Cestino":
                        this.emailCustomMessage = this.smartBinMessage;
                        break;
                    case "Button":
                        this.emailCustomMessage = this.smartButtonMessage;
                        break;
                    default:
                        this.emailCustomMessage = '';
                        break;
                }
            }
            
            this.dialogAlert = true;

        }
    },
    watch: {
        // Watch per i filtri della ricerca
        filterClient(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.filterAreas.length = 0;
                this.filterArea = '';
                this.filterAreas = [];
                this.filterFloors.length = 0;
                this.filterFloor = '';
                this.filterFloors = [];
                this.filterBuildings.length = 0;
                this.filterBuilding = '';
                this.filterBuildings = [];
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                var el = { text: "...", value: "" };
                this.filterBuildings.push(el);
                axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, {
                    companyId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.BuildingName, value: el.id }
                            this.filterBuildings.push(element);
                        });
                        // Applica automaticamente il filtro
                        this.GetAlertData();
                    })
            }
            else {
                this.filterAreas.length = 0;
                this.filterArea = '';
                this.filterAreas = [];
                this.filterFloors.length = 0;
                this.filterFloor = '';
                this.filterFloors = [];
                this.filterBuildings.length = 0;
                this.filterBuilding = '';
                this.filterBuildings = [];
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                // Applica automaticamente il filtro
                this.GetAlertData();
            }
        },
        filterBuilding(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.filterAreas.length = 0;
                this.filterArea = '';
                this.filterAreas = [];
                this.filterFloors.length = 0;
                this.filterFloor = '';
                this.filterFloors = [];
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                var el = {text: "..." , value: ""};
                this.filterFloors.push(el);
                axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
                    buildingId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.FloorName, value: el.id }
                            this.filterFloors.push(element);
                        });
                        // Applica automaticamente il filtro
                        this.GetAlertData();
                    })
            } else {
                this.filterAreas.length = 0;
                this.filterArea = '';
                this.filterAreas = [];
                this.filterFloors.length = 0;
                this.filterFloor = '';
                this.filterFloors = [];
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                // Applica automaticamente il filtro
                this.GetAlertData();
            }
        },
        filterFloor(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.filterAreas.length = 0;
                this.filterArea = '';
                this.filterAreas = [];
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                var el = {text: "..." , value: ""};
                this.filterAreas.push(el);
                axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
                    floorId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.AreaName, value: el.id }
                            this.filterAreas.push(element);
                        });
                        // Applica automaticamente il filtro
                        this.GetAlertData();
                    })
            }
            else{
                this.filterAreas.length = 0;
                this.filterArea = '';
                this.filterAreas = [];
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                // Applica automaticamente il filtro
                this.GetAlertData();
            }
        },
        filterArea(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
                    companyId: this.filterClient,
                    buildingId: this.filterBuilding,
                    floorId: this.filterFloor,
                    areaId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.DispenserUnique, value: el.id }
                            this.filterSensors.push(element);
                        });
                        // Applica automaticamente il filtro
                        this.GetAlertData();
                    })
            }
            else{
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                // Applica automaticamente il filtro
                this.GetAlertData();
            }
        },
        filterSensor(value) {
            // Applica automaticamente il filtro quando viene selezionato un sensore
            if (value !== undefined && value !== null) {
                this.GetAlertData();
            }
        },
        // Watch per i campi del dialog di creazione/modifica
        client(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.showFloor = false;
                this.showArea = false;
                this.floors.length = 0;
                this.areas.length = 0;
                this.areas = [];
                this.floors = [];
                this.showBuilding = true;
                this.buildings.length = 0;
                this.buildings = [];
                this.building = '';
                this.sensor = '';
                this.sensors = [];
                this.sensors.length = 0;
                this.filteredSensors = '';
                this.filteredSensors = [];
                this.filteredSensors.length = 0;
                axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, {
                    companyId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.BuildingName, value: el.id }
                            this.buildings.push(element);

                        });
                        axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
                            companyId: value

                        })
                            .then(res => {
                                res.data.forEach(el => {
                                    var element = { text: el.DisplayName, value: el }
                                    this.filteredSensors.push(element);
                                    this.sensors.push(element);
                                });

                            })
                    })
            }
            else {
                this.showBuilding = false;
                this.buildings.length = 0;
                this.building = '';
                this.floors.length = 0;
                this.areas.length = 0;
                this.areas = [];
                this.floors = [];
                this.buildings = [];
            }
        },
        building(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.showFloor = true;
                this.floors.length = 0;
                this.floor = '';
                this.areas.length = 0;
                this.areas = [];
                this.area = '';
                this.floors = [];
                this.sensors = [];
                this.sensors.length = 0;
                this.sensor = "";
                this.filteredSensors = '';
                this.filteredSensors = [];
                this.filteredSensors.length = 0;
                axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
                    buildingId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.FloorName, value: el.id }
                            this.floors.push(element);
                        });
                        axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
                            companyId: this.client,
                            buildingId: value,

                        })
                            .then(res => {
                                res.data.forEach(el => {
                                    var element = { text: el.DisplayName, value: el }
                                    this.filteredSensors.push(element);
                                    this.sensors.push(element);
                                });

                            })
                    })
            }
            else {
                this.showFloor = false;
                this.floors.length = 0;
                this.floor = '';
                this.area = '';
                this.areas = [];
                this.floors = [];
            }
        },
        filterbuilding(value) {
            if (value == "ALL") {
                this.items = this.items_all;
            }
            else {
                this.items = this.items_all.filter(p => p.BuildingName == value);
            }
        },
        floor(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.showArea = true;
                this.areas.length = 0;
                this.area = '';
                this.areas = [];
                this.sensors = [];
                this.sensors.length = 0;
                this.sensor = "";
                this.filteredSensors = '';
                this.filteredSensors = [];
                this.filteredSensors.length = 0;
                axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
                    floorId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.AreaName, value: el.id }
                            this.areas.push(element);

                        });
                        axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
                            companyId: this.client,
                            buildingId: this.building,
                            floorId: value,

                        })
                            .then(res => {
                                res.data.forEach(el => {
                                    var element = { text: el.DisplayName, value: el }
                                    this.filteredSensors.push(element);
                                    this.sensors.push(element);
                                });

                            })
                    })
            }
            else {
                this.showArea = false;
                this.areas.length = 0;
                this.areas = [];
                this.area = '';
            }

        },
        sensore(value) {

            this.id_sensore = value.DispenserUnique;
            this.display_name = value.DisplayName;
            if (this.id_sensore == undefined) {
                this.id_sensore = value.value.DispenserUnique;
                this.display_name = value.value.DisplayName;
            }
        },
        area(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.sensors.length = 0;
                this.sensor = '';
                this.sensors = [];
                this.showSensor = true;
                this.filteredSensors = '';
                this.filteredSensors = [];
                this.filteredSensors.length = 0;
                axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
                    companyId: this.client,
                    buildingId: this.building,
                    floorId: this.floor,
                    areaId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.DisplayName, value: el }
                            this.filteredSensors.push(element);
                            this.sensors.push(element);
                        });

                    })
            }
        },
        sensor(value) {
            var type = "";
            if (value.length == 0) {
                this.filteredSensors = this.sensors;
                this.showAirFieldSelect = false;
                this.showButtonFieldSelect = false;
                this.showAlertValueField = true;
                this.alertField = '';
                this.comparisonOperator = '';
            }

            if (value.length == 1) {
                type = value[0].DispenserType;
                const subtype = value[0].DispenserSubtype;
                
                // Mostra il campo Air select solo se è un sensore Air
                if (type === "Air") {
                    this.showAirFieldSelect = true;
                    this.showButtonFieldSelect = false;
                    this.showAlertValueField = true;
                } else if (type === "Button") {
                    this.showAirFieldSelect = false;
                    this.comparisonOperator = '';
                    
                // Mostra il campo tipo di click solo per Button con subtype 'click'
                // e nascondi il campo alertValue per questi sensori
                if (subtype === 'click') {
                    this.showButtonFieldSelect = true;
                    this.showAlertValueField = false;
                    this.alertValue = 0; // Reset alertValue per Button click
                } else {
                    this.showButtonFieldSelect = false;
                    this.showAlertValueField = true;
                }
                } else {
                    this.showAirFieldSelect = false;
                    this.showButtonFieldSelect = false;
                    this.showAlertValueField = true;
                    this.alertField = '';
                    this.comparisonOperator = '';
                }
                
                switch (type) {
                    case "Dispenser":
                        this.emailCustomMessage = this.dispenserMessage;
                        break;
                    case "Air":
                        this.emailCustomMessage = this.airMessage;
                        break;
                    case "Washroom":
                        this.emailCustomMessage = this.doorMessage;
                        break;
                    case "Cestino":
                        this.emailCustomMessage = this.smartBinMessage;
                        break;
                    case "Button":
                        this.emailCustomMessage = this.smartButtonMessage;
                        break;
                }
                console.log(type)
                console.log(this.emailCustomMessage)
                this.filteredSensors = this.sensors.filter(
                    (sensor) => sensor.value.DispenserType === type
                );
            }
            
            // Se vengono selezionati più sensori, nascondi i campi Air e Button
            if (value.length > 1) {
                this.showAirFieldSelect = false;
                this.showButtonFieldSelect = false;
                this.showAlertValueField = true;
                this.alertField = '';
                this.comparisonOperator = '';
            }
        }
    }
}
</script>
<style scoped>
/*.v-card__subtitle, .v-card__text{
        color: #213A8F !important;
     }*/
.theme--light.v-icon {
    color: #213A8F;
}

.v-list-item__title,
.v-list-item__subtitle {
    color: #234a98 !important;
}

.v-icon.v-icon :not(.v-icon.v-icon[data-v-43d5ffb9]) {
    color: #234a98 !important;
}

/* Responsive table styles */
.table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.email-cell {
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Media queries per schermi piccoli */
@media (max-width: 960px) {
    .email-cell {
        max-width: 200px;
    }
}

@media (max-width: 600px) {
    .email-cell {
        max-width: 150px;
    }
    
    .v-data-table >>> td,
    .v-data-table >>> th {
        padding: 0 8px !important;
        font-size: 0.875rem;
    }
    
    .v-icon {
        font-size: 20px !important;
    }
}
</style>
